import React from "react";
import PropTypes from "prop-types";

import {
  CellContainer,
  GuidesListImgContainer,
  GuidesListImg,
  GuidesListTextContainer,
  Description,
  SeeMoreTag,
  SeeMoreTagSpan,
  StyledTitle,
} from "./style";

const GuidesTabCell = ({ title, description = null, image, isGlossary, toUrlLink, location }) => {
  const { search } = location || {};

  /**
   * NOTE: Descriptions/Excerpts are not currently shown for each listing. It's only used in <PageMeta>.
   * Formats the excerpt,
   * when excerpt is automatically created by Ghost using the first part of the article details,
   * which could have sub header title with icons. Eg Header Demo --cellarIcon.
   *
   * @param {String} desc
   * */
  const formattedDescription = (desc) => {
    const filtered = desc.replace(/(--)\w*/gm, "");
    return `${filtered}`;
  };

  return (
    <CellContainer
      to={{
        pathname: toUrlLink,
        search,
      }}
    >
      <GuidesListImgContainer>{image && <GuidesListImg src={image} alt={title} />}</GuidesListImgContainer>
      <GuidesListTextContainer>
        <StyledTitle tag={3} fontSecondary mbSmall>
          {title}
        </StyledTitle>
        {description && <Description>{formattedDescription(description)}</Description>}
        <SeeMoreTagSpan>
          <SeeMoreTag isGlossary={isGlossary}>{isGlossary ? "MORE CONTENT" : "ARTICLE"}</SeeMoreTag>
        </SeeMoreTagSpan>
      </GuidesListTextContainer>
    </CellContainer>
  );
};

GuidesTabCell.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  isGlossary: PropTypes.bool.isRequired,
  toUrlLink: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabCell;
